export const BaseURL = process.env.REACT_APP_API_BASE_URL;
